module.exports = __webpack_public_path__ + "img/shopify-three-2-cn.79db5ee8.png";